<!--  -->
<template>
    <div class="business-content-main settlement">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-ctn-left">
                <el-button size="small" icon="el-icon-plus" class="search-btn btn-primary" @click="showSettleOpDialog(0)" v-if="permission.addSettleRecords">{{
                    permission.addSettleRecords
                }}</el-button>
                <el-button size="small" icon="el-icon-printer" class="search-btn btn-primary" @click="print()" v-if="permission.print">{{ permission.print }}</el-button>
                <el-button size="small" class="search-btn btn-primary" @click="exportForm()" v-if="permission.exportRecords"
                    ><i class="fa fa-file-excel-o"></i> {{ permission.exportRecords }}</el-button
                >
                <el-button size="small" icon="el-icon-document" class="search-btn btn-primary" @click="gotoFlows()" v-if="permission.allFlows">{{ permission.allFlows }}</el-button>
                <el-button size="small" icon="el-icon-s-data" class="search-btn btn-primary" @click="showCount">合计</el-button>
                <el-button size="small" type="warning" icon="el-icon-connection" class="search-btn" @click="entityRele()" v-if="permission.entityRele">{{
                    permission.entityRele
                }}</el-button>
            </div>
            <div class="search-ctn-right">
                <div class="search-name">客户/供应商</div>
                <el-select
                    class="search-item"
                    size="small"
                    v-model="searchData.CName"
                    remote
                    filterable
                    allow-create
                    placeholder="客户/供应商名称"
                    :remote-method="searchCustom"
                    v-select-scroll-more="searchCustomLoad"
                >
                    <el-option v-for="item in cusOptions" :key="item.EntpCusId" :label="item.EntpCusName" :value="item.EntpCusName"></el-option>
                </el-select>
                <div class="search-name">结算单号</div>
                <el-input class="search-item" size="small" v-model.trim="searchData.OrderCode" placeholder="结算单号"></el-input>
                <div class="search-name">单据状态</div>
                <el-select class="search-item" size="small" v-model="searchData.State">
                    <el-option v-for="item in stateList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                </el-select>
                <div class="search-name">创建日期</div>
                <i class="el-icon-date search-name time-btn" @click="timeVisible = true"></i>
                <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
            </div>
        </div>
        <div class="table-ctn">
            <el-table
                :header-cell-style="{ background: '#F2F6FC' }"
                border=""
                :data="tableData"
                ref="multipleTable"
                @selection-change="handleSelectionChange"
                style="width: 100%"
                :tableCode="tableCode"
                :row-class-name="tableRowClassName"
                @cell-click="cellClickHandle"
                @row-click="rowClickHandle"
            >
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column
                    v-if="columnShowSets.OrderCode.IsShow"
                    :width="columnShowSets.OrderCode.Width > 0 ? columnShowSets.OrderCode.Width + 'px' : '180px'"
                    :label="columnShowSets.OrderCode.ColumnName"
                    prop="OrderCode"
                    show-overflow-tooltip
                >
                    <template slot-scope="scope">
                        <el-button @click="handleDBClick(scope.row)" type="text">
                            {{ scope.row.OrderCode }}
                        </el-button>
                    </template>
                </el-table-column>
                <el-table-column
                    v-if="columnShowSets.EntpCusName.IsShow"
                    :min-width="columnShowSets.EntpCusName.Width > 0 ? columnShowSets.EntpCusName.Width + 'px' : '200px'"
                    :label="columnShowSets.EntpCusName.ColumnName"
                    prop="EntpCusName"
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                    v-if="columnShowSets.StartTime.IsShow"
                    :min-width="columnShowSets.StartTime.Width > 0 ? columnShowSets.StartTime.Width + 'px' : '120px'"
                    :label="columnShowSets.StartTime.ColumnName"
                    prop="StartTime"
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                    v-if="columnShowSets.EndTime.IsShow"
                    :min-width="columnShowSets.EndTime.Width > 0 ? columnShowSets.EndTime.Width + 'px' : '120px'"
                    :label="columnShowSets.EndTime.ColumnName"
                    prop="EndTime"
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                    v-if="columnShowSets.OpeningBalance.IsShow"
                    :width="columnShowSets.OpeningBalance.Width > 0 ? columnShowSets.OpeningBalance.Width + 'px' : '90px'"
                    :label="columnShowSets.OpeningBalance.ColumnName"
                    prop="OpeningBalance"
                    show-overflow-tooltip
                >
                    <template scope="scope">{{ scope.row.OpeningBalance == 0 ? '-' : scope.row.OpeningBalance }}</template>
                </el-table-column>

                <el-table-column
                    v-if="columnShowSets.AdvancePayment.IsShow"
                    :width="columnShowSets.AdvancePayment.Width > 0 ? columnShowSets.AdvancePayment.Width + 'px' : '90px'"
                    :label="columnShowSets.AdvancePayment.ColumnName"
                    prop="AdvancePayment"
                    show-overflow-tooltip
                    ><template scope="scope">{{ scope.row.AdvancePayment == 0 ? '-' : scope.row.AdvancePayment }}</template></el-table-column
                >
                <el-table-column
                    v-if="columnShowSets.NeedReceive.IsShow"
                    :width="columnShowSets.NeedReceive.Width > 0 ? columnShowSets.NeedReceive.Width + 'px' : '90px'"
                    :label="columnShowSets.NeedReceive.ColumnName"
                    prop="NeedReceive"
                    show-overflow-tooltip
                    ><template scope="scope">{{ scope.row.NeedReceive == 0 ? '-' : scope.row.NeedReceive }}</template></el-table-column
                >
                <el-table-column
                    v-if="columnShowSets.AdvanceReceived.IsShow"
                    :width="columnShowSets.AdvanceReceived.Width > 0 ? columnShowSets.AdvanceReceived.Width + 'px' : '90px'"
                    :label="columnShowSets.AdvanceReceived.ColumnName"
                    prop="AdvanceReceived"
                    show-overflow-tooltip
                    ><template scope="scope">{{ scope.row.AdvanceReceived == 0 ? '-' : scope.row.AdvanceReceived }}</template></el-table-column
                >
                <el-table-column
                    v-if="columnShowSets.NeedPay.IsShow"
                    :width="columnShowSets.NeedPay.Width > 0 ? columnShowSets.NeedPay.Width + 'px' : '90px'"
                    :label="columnShowSets.NeedPay.ColumnName"
                    prop="NeedPay"
                    show-overflow-tooltip
                    ><template scope="scope">{{ scope.row.NeedPay == 0 ? '-' : scope.row.NeedPay }}</template></el-table-column
                >
                <el-table-column
                    v-if="columnShowSets.ClosingBalance.IsShow"
                    :min-width="columnShowSets.ClosingBalance.Width > 0 ? columnShowSets.ClosingBalance.Width + 'px' : '90px'"
                    :label="columnShowSets.ClosingBalance.ColumnName"
                    prop="ClosingBalance"
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                    v-if="columnShowSets.StateName.IsShow"
                    :width="columnShowSets.StateName.Width > 0 ? columnShowSets.StateName.Width + 'px' : '90px'"
                    :label="columnShowSets.StateName.ColumnName"
                    prop="StateName"
                    show-overflow-tooltip
                >
                    <template slot-scope="scope">
                        <i v-if="scope.row.StateName == '已结算'" class="c-active">{{ scope.row.StateName }}</i>
                        <i v-else>{{ scope.row.StateName }}</i></template
                    >
                </el-table-column>
                <el-table-column
                    v-if="columnShowSets.UnPaid.IsShow"
                    :min-width="columnShowSets.UnPaid.Width > 0 ? columnShowSets.UnPaid.Width + 'px' : '100px'"
                    :label="columnShowSets.UnPaid.ColumnName"
                    prop="UnPaid"
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                    prop="Remark"
                    v-if="columnShowSets.Remark.IsShow"
                    :min-width="columnShowSets.Remark.Width > 0 ? columnShowSets.Remark.Width + 'px' : '200px'"
                    :label="columnShowSets.Remark.ColumnName"
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                    prop="Operator"
                    v-if="columnShowSets.Operator.IsShow"
                    :min-width="columnShowSets.Operator.Width > 0 ? columnShowSets.Operator.Width + 'px' : '80px'"
                    :label="columnShowSets.Operator.ColumnName"
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                    prop="CreateTime"
                    sortable
                    v-if="columnShowSets.CreateTime.IsShow"
                    :min-width="columnShowSets.CreateTime.Width > 0 ? columnShowSets.CreateTime.Width + 'px' : '160px'"
                    :label="columnShowSets.CreateTime.ColumnName"
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column fixed="right" label="操作" :autoWidth="true" :isCanSet="true" prop="optb">
                    <template slot-scope="scope">
                        <div class="ops-ctn">
                            <el-button
                                v-if="permission.editSettleRecords && scope.row.State == 0"
                                title="编辑"
                                size="mini"
                                type="text"
                                @click="showSettleOpDialog(1, scope.row.SettleId)"
                                >{{ permission.editSettleRecords }}</el-button
                            >
                            <el-button v-if="permission.submit && scope.row.State == 0" title="提交结算单" size="mini" type="text" @click="submitSettlement(scope.row.SettleId)">{{
                                permission.submit
                            }}</el-button>
                            <el-button
                                v-if="permission.cancel && scope.row.State == 1"
                                size="mini"
                                type="text"
                                style="color: #e6a23c"
                                @click="cancelSettlement(scope.row.SettleId)"
                                >{{ permission.cancel }}</el-button
                            >
                            <el-button
                                v-if="permission.del && (scope.row.State == 2 || scope.row.State == 0)"
                                title="删除"
                                size="mini"
                                type="text"
                                style="color: red"
                                @click="delSettlement(scope.row.SettleId)"
                                >{{ permission.del }}</el-button
                            >
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination-ctn">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="searchData.page"
                :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                :page-size="searchData.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="tableDataLength"
            ></el-pagination>
        </div>
        <el-dialog :close-on-click-modal="false" title="创建时间" :visible.sync="timeVisible" width="800px">
            <div class="dialog-content" v-if="timeVisible">
                <timePicker @timerSearch="timerSearch" :start="this.searchData.StartDate" :end="this.searchData.EndDate"></timePicker>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="实体关联" :visible.sync="showEntityVisible" width="1000px">
            <div class="dialog-content" v-if="showEntityVisible">
                <entityReles EntpCusId="" @closeDialog="closeDialog"></entityReles>
            </div>
        </el-dialog>
        <el-dialog
            :close-on-click-modal="false"
            :title="settleOpTitle"
            :visible.sync="isShowSettleOpDialog"
            :append-to-body="true"
            v-dialog-drag
            :modal="false"
            lock-scroll
            id="change-dialog"
            style="margin-left: -600px"
        >
            <div v-if="isShowSettleOpDialog" class="settle-op-content">
                <settleOp ref="settleOp" @closeDialog="closeSettleOpDialog" :SettleId="this.SettleId" :SType="this.SType"></settleOp>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="打印" :visible.sync="printVisible" width="870px">
            <div class="dialog-content" v-if="printVisible">
                <printContent @closeDialog="closeDialog" :SettleId="idList[0]"></printContent>
            </div>
        </el-dialog>
        <el-dialog
            :close-on-click-modal="false"
            title="结算明细"
            :visible.sync="drawerVisible"
            v-dialog-drag
            :modal="false"
            append-to-body
            lock-scroll
            id="change-dialog"
            style="margin-left: -600px"
        >
            <div v-if="drawerVisible">
                <SettleDetails ref="SettleDetails" dragSign="settleDetail" :SettleId="SettleId" @closeDialog="closedDrawerHandle"></SettleDetails>
            </div>
        </el-dialog>

        <el-dialog
            :close-on-click-modal="false"
            title="合计"
            @close="
                () => {
                    this.statisticsVisible = false;
                }
            "
            :visible.sync="statisticsVisible"
            width="500px"
        >
            <div class="dialog-content" v-if="statisticsVisible">
                <statistics :countData="multipleSelection" type="settlement"></statistics>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import elTableColumn from '@/components/common/chjtablecolumn';
import breadcrumb from '@/components/common/breadcrumb';
import timePicker from '@/components/common/timePicker';
import entityReles from '@/components/business/revenue/entityReles';
import settleOp from '@/components/business/revenue/settleOp';
import printContent from '@/components/business/revenue/printSettlement';
import SettleDetails from '@/components/business/revenue/settleDetails';
import statistics from '@/components/common/statistics.vue';
import pageLimitMixin from '@/mixins/pageLimitMixin';
export default {
    mixins: [pageLimitMixin],
    name: '',
    components: {
        timePicker,
        breadcrumb,
        entityReles,
        settleOp,
        elTableColumn,
        printContent,
        SettleDetails,
        statistics
    },
    data() {
        return {
            tableCode: 'Settlement',
            settleOpTitle: '',
            timeVisible: false,
            printVisible: false,
            statisticsVisible: false,
            showEntityVisible: false,
            isShowSettleOpDialog: false,
            multipleSelection: [],
            idList: [],
            searchData: {
                CName: '',
                OrderCode: '',
                State: '-1',
                StartDate: '',
                EndDate: '',
                page: 1,
                limit: 15
            },
            SType: 0,
            SettleId: '',
            tableData: [],
            tableDataLength: 0,
            stateList: [
                { Text: '全部', Value: '-1' },
                { Text: '未提交', Value: '0' },
                { Text: '已提交', Value: '1' },
                { Text: '已结部分', Value: '3' },
                { Text: '已结算', Value: '4' },
                { Text: '已撤销', Value: '2' }
            ],
            permission: {},
            columnShowSets: {
                OrderCode: { ColumnName: '', IsShow: false, Width: 0 },
                EntpCusName: { ColumnName: '', IsShow: false, Width: 0 },
                StartTime: { ColumnName: '', IsShow: false, Width: 0 },
                EndTime: { ColumnName: '', IsShow: false, Width: 0 },
                OpeningBalance: { ColumnName: '', IsShow: false, Width: 0 },
                AdvancePayment: { ColumnName: '', IsShow: false, Width: 0 },
                NeedReceive: { ColumnName: '', IsShow: false, Width: 0 },
                AdvanceReceived: { ColumnName: '', IsShow: false, Width: 0 },
                NeedPay: { ColumnName: '', IsShow: false, Width: 0 },
                StateName: { ColumnName: '', IsShow: false, Width: 0 },
                ClosingBalance: { ColumnName: '', IsShow: false, Width: 0 },
                Operator: { ColumnName: '', IsShow: false, Width: 0 },
                CreateTime: { ColumnName: '', IsShow: false, Width: 0 },
                Remark: { ColumnName: '', IsShow: false, Width: 0 },
                UnPaid: { ColumnName: '', IsShow: false, Width: 0 }
            },
            // 用于客户名称列表，分页搜索
            cusOptions: [],
            cusForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            // 查看结算明细弹框
            drawerVisible: false,
            drawerIndex: '',
            drawerList: []
        };
    },
    created() {
        if (this.tableCode) this.getSetsData();
    },
    mounted() {
        this.getTableData();
        this.searchCustom();
        this.getPay();
        this.$util.setEnterEvent(this, this.$route.fullPath);
        this.permission = this.$util.getPermission('Settlement');
        document.addEventListener('keyup', this.handleKeyup);
    },
    beforeRouteLeave(to, form, next) {
        document.removeEventListener('keyup', this.handleKeyup, false);
        next();
    },
    watch: {
        NeedRefresh(value) {
            if (value.NeedRefresh) {
                this.getTableData();
            }
        }
    },
    computed: {
        NeedRefresh() {
            return this.$route.query;
        }
    },
    methods: {
        handleKeyup(event) {
            if (event.key == 'Escape') {
                this.drawerVisible = false;
                this.isShowSettleOpDialog = false;
            }
        },
        // 单击一行触发
        rowClickHandle(row) {
            if (this.drawerVisible && this.$refs.SettleDetails) {
                this.$refs.SettleDetails.updateTableData(row.SettleId);
            }
            if (this.isShowSettleOpDialog) {
                this.$refs.settleOp.updateTableData(row.SettleId);
            }
        },
        // 单击单元格，限制只能点击结算单号列
        cellClickHandle(row, column) {
            if (column.property === 'optb' || column.property === 'OrderCode') return;
            // this.tableData.forEach((ele, index) => {
            //   this.$set(this.tableData, index, Object.assign(ele, {active: row.RowIndex === index}));
            // });
            // this.drawerIndex = row.RowIndex;
            if (!this.drawerVisible) {
                this.SettleId = row.SettleId;
                this.drawerVisible = true;
            }
            // this.getDrawerData(row.SettleId);
        },
        // 行样式
        tableRowClassName({ row, rowIndex }) {
            row.RowIndex = rowIndex;
            if (row.active) {
                return 'active';
            }
        },
        // 关闭结算明细弹框
        closedDrawerHandle() {
            this.drawerVisible = false;
        },
        // 客户名称列表，搜索
        async searchCustom(key) {
            if (![undefined].includes(key)) {
                this.cusForm.Page = 1;
                this.cusForm.stopLoad = false;
                this.cusForm.key = key;
                this.cusOptions = [];
            }
            if (this.cusForm.stopLoad) return;
            const data = await this.$util.searchCustomerAndSupplier(this.cusForm.key, this.cusForm.Page, this.cusForm.Limit);
            if (data) {
                if (!data) return;
                this.cusForm.stopLoad = data.length < this.cusForm.Limit;
                this.cusOptions = [...this.cusOptions, ...data];
            }
        },
        // 客户名称列表，加载更多
        searchCustomLoad() {
            this.cusForm.Page += 1;
            this.searchCustom();
        },
        getPay() {
            this.$util.getPay().then(data => {
                this.payWayList = data;
            });
        },
        timerSearch(timer) {
            this.timeVisible = false;
            this.searchData.StartDate = timer.start;
            this.searchData.EndDate = timer.end;
            this.handleSearch();
        },
        // 显示统计
        showCount() {
            if (this.multipleSelection && this.multipleSelection.length > 0) {
                this.statisticsVisible = true;
            } else {
                this.$util.warningMsg('请至少选择一条数据');
            }
        },
        closeDialog() {
            this.$refs.multipleTable.clearSelection();
            this.multipleSelection = null;
            this.statisticsVisible = false;
            this.showEntityVisible = false;
            this.printVisible = false;
        },
        // 勾选统计
        handleSelectionChange(val) {
            this.multipleSelection = val;
            let idList = [];
            for (let i = 0; i < val.length; i++) {
                idList.push(val[i].SettleId);
            }
            this.idList = idList;
        },
        resetSearch() {
            this.searchData = {
                CName: '',
                OrderCode: '',
                State: '-1',
                StartDate: '',
                EndDate: '',
                page: 1,
                limit: this.commonPageSize
            };
            this.searchCustom('');
        },
        getTableData() {
            this.$util
                .axiosGet({
                    url: '/api/RevenueManagement/GetSettlementsList',
                    data: this.searchData
                })
                .then(res => {
                    let data = res.data;
                    if (!data) data = [];
                    this.tableData = data;
                    this.tableDataLength = res.count;
                });
        },
        handleSearch() {
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        handleDBClick(event) {
            if (event.SettleId) {
                this.showSettleOpDialog(2, event.SettleId);
            }
        },
        print() {
            if (this.idList.length == 0) {
                this.$util.warningMsg('请选择一张结算单进行打印');
                return;
            } else if (this.idList.length > 1) {
                this.$util.warningMsg('只能选择一张结算单进行打印');
                return;
            }
            this.printVisible = true;
        },
        exportForm() {
            if (this.idList.length == 0) {
                this.$util.warningMsg('请选择导出一张结算单');
                return;
            } else if (this.idList.length > 1) {
                this.$util.warningMsg('只能导出一张结算单');
                return;
            }
            this.$util.exportFile({
                url: '/api/RevenueManagement/ExportSettlements',
                data: {
                    SettleId: this.idList[0]
                }
            });
        },
        entityRele() {
            this.showEntityVisible = true;
        },
        gotoFlows() {
            this.$router.push(`/financeManage/records`);
        },
        closeSettleOpDialog() {
            this.isShowSettleOpDialog = false;
            this.getTableData();
        },
        showSettleOpDialog(type, settleId) {
            this.SType = type;
            if (type === 0) {
                this.SettleId = '';
                this.settleOpTitle = '新增结算单';
            } else if (type === 1) {
                if (settleId) {
                    this.SettleId = settleId;
                    this.settleOpTitle = '编辑结算单';
                } else {
                    this.$util.warningMsg('结算单异常，请刷新后重试');
                }
            } else {
                if (settleId) {
                    this.SettleId = settleId;
                    this.settleOpTitle = '查看结算单';
                } else {
                    this.$util.warningMsg('结算单异常，请刷新后重试');
                }
            }
            this.isShowSettleOpDialog = true;
        },
        submitSettlement(settleId) {
            if (settleId) {
                this.$confirm('您确定要提交该结算单吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    center: false
                })
                    .then(() => {
                        this.loading = true;
                        this.$util
                            .axiosPost({
                                url: `/api/RevenueManagement/SubmitSettlementDatas?SettleId=${settleId}`,
                                hideLoading: true
                            })
                            .then(res => {
                                this.$util.successMsg('提交成功');
                                this.getTableData();
                            })
                            .finally(() => {
                                this.loading = false;
                            });
                    })
                    .catch(() => {});
            } else {
                this.$util.warningMsg('请刷新后重新操作');
            }
        },
        cancelSettlement(settleId) {
            if (settleId) {
                this.$confirm('您确定要撤销该结算单吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    center: false
                })
                    .then(() => {
                        this.loading = true;
                        this.$util
                            .axiosPost({
                                url: `/api/RevenueManagement/CancelSettlementDatas?SettleId=${settleId}`,
                                hideLoading: true
                            })
                            .then(res => {
                                this.$util.successMsg('撤销成功');
                                this.getTableData();
                            })
                            .finally(() => {
                                this.loading = false;
                            });
                    })
                    .catch(() => {});
            } else {
                this.$util.warningMsg('请刷新后重新操作');
            }
        },
        delSettlement(settleId) {
            if (settleId) {
                this.$confirm('您确定要删除该结算单吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    center: false
                })
                    .then(() => {
                        this.loading = true;
                        this.$util
                            .axiosPost({
                                url: `/api/RevenueManagement/DelSettlementDatas?SettleId=${settleId}`,
                                hideLoading: true
                            })
                            .then(res => {
                                this.$util.successMsg('删除成功');
                                this.getTableData();
                            })
                            .finally(() => {
                                this.loading = false;
                            });
                    })
                    .catch(() => {});
            } else {
                this.$util.warningMsg('请刷新后重新操作');
            }
        },
        getSetsData() {
            this.$util.getTableSetsData(this.tableCode, true).then(data => {
                data.forEach(item => {
                    switch (item.ColumnCode) {
                        case 'OrderCode':
                            this.columnShowSets.OrderCode.IsShow = item.IsShow;
                            this.columnShowSets.OrderCode.Width = item.Width;
                            this.columnShowSets.OrderCode.ColumnName = item.ColumnName;
                            break;
                        case 'EntpCusName':
                            this.columnShowSets.EntpCusName.IsShow = item.IsShow;
                            this.columnShowSets.EntpCusName.Width = item.Width;
                            this.columnShowSets.EntpCusName.ColumnName = item.ColumnName;
                            break;
                        case 'StartTime':
                            this.columnShowSets.StartTime.IsShow = item.IsShow;
                            this.columnShowSets.StartTime.Width = item.Width;
                            this.columnShowSets.StartTime.ColumnName = item.ColumnName;
                            break;
                        case 'EndTime':
                            this.columnShowSets.EndTime.IsShow = item.IsShow;
                            this.columnShowSets.EndTime.Width = item.Width;
                            this.columnShowSets.EndTime.ColumnName = item.ColumnName;
                            break;
                        case 'OpeningBalance':
                            this.columnShowSets.OpeningBalance.IsShow = item.IsShow;
                            this.columnShowSets.OpeningBalance.Width = item.Width;
                            this.columnShowSets.OpeningBalance.ColumnName = item.ColumnName;
                            break;
                        case 'AdvancePayment':
                            this.columnShowSets.AdvancePayment.IsShow = item.IsShow;
                            this.columnShowSets.AdvancePayment.Width = item.Width;
                            this.columnShowSets.AdvancePayment.ColumnName = item.ColumnName;
                            break;
                        case 'NeedReceive':
                            this.columnShowSets.NeedReceive.IsShow = item.IsShow;
                            this.columnShowSets.NeedReceive.Width = item.Width;
                            this.columnShowSets.NeedReceive.ColumnName = item.ColumnName;
                            break;
                        case 'AdvanceReceived':
                            this.columnShowSets.AdvanceReceived.IsShow = item.IsShow;
                            this.columnShowSets.AdvanceReceived.Width = item.Width;
                            this.columnShowSets.AdvanceReceived.ColumnName = item.ColumnName;
                            break;
                        case 'NeedPay':
                            this.columnShowSets.NeedPay.IsShow = item.IsShow;
                            this.columnShowSets.NeedPay.Width = item.Width;
                            this.columnShowSets.NeedPay.ColumnName = item.ColumnName;
                            break;
                        case 'ClosingBalance':
                            this.columnShowSets.ClosingBalance.IsShow = item.IsShow;
                            this.columnShowSets.ClosingBalance.Width = item.Width;
                            this.columnShowSets.ClosingBalance.ColumnName = item.ColumnName;
                            break;
                        case 'StateName':
                            this.columnShowSets.StateName.IsShow = item.IsShow;
                            this.columnShowSets.StateName.Width = item.Width;
                            this.columnShowSets.StateName.ColumnName = item.ColumnName;
                            break;
                        case 'Operator':
                            this.columnShowSets.Operator.IsShow = item.IsShow;
                            this.columnShowSets.Operator.Width = item.Width;
                            this.columnShowSets.Operator.ColumnName = item.ColumnName;
                            break;
                        case 'Remark':
                            this.columnShowSets.Remark.IsShow = item.IsShow;
                            this.columnShowSets.Remark.Width = item.Width;
                            this.columnShowSets.Remark.ColumnName = item.ColumnName;
                            break;
                        case 'CreateTime':
                            this.columnShowSets.CreateTime.IsShow = item.IsShow;
                            this.columnShowSets.CreateTime.Width = item.Width;
                            this.columnShowSets.CreateTime.ColumnName = item.ColumnName;
                            break;
                        case 'UnPaid':
                            this.columnShowSets.UnPaid.IsShow = item.IsShow;
                            this.columnShowSets.UnPaid.Width = item.Width;
                            this.columnShowSets.UnPaid.ColumnName = item.ColumnName;
                            break;
                    }
                });
            });
        }
    }
};
</script>
<style lang="less">
.c-active {
    color: #0dbdae;
}
.settlement {
    .table-ctn {
        cursor: pointer;
        .active .cell {
            color: #409eff;
        }
    }
}
#change-dialog {
    position: absolute;
    top: 0;
    left: 50%;
    right: auto;
    bottom: auto;
    width: 10px;
    height: 10px;
    overflow: visible;
    .el-dialog {
        width: 1200px;
        height: auto;
        box-shadow: 0 0 9px 3px #999;
    }
    .el-dialog__body {
        padding: 0;
        overflow: auto;
    }
    .settle-content {
        padding: 10px 20px;
    }
}
#change-dialog::-webkit-scrollbar {
    display: none;
}
</style>
